import blankCells from "./blank-cells.js";

export default function generate(w, h, wallCount) {
	const cells = blankCells(w, h);
	const usedWalls = new Set();
	while (usedWalls.size < wallCount) {
		const x = Math.round(Math.random() * w * 2 - 2), y = Math.round(Math.random() * h * 2 - 2);
		if (x < 1 || y < 1) continue;
		if ((x & 1) == (y & 1)) continue;
		const k = `${x}-${y}`; if (usedWalls.has(k)) continue; usedWalls.add(k);
		if (usedWalls.has(`${x-1}-${y-1}`) ||  usedWalls.has(`${x+1}-${y-1}`) || usedWalls.has(`${x-1}-${y+1}`) || usedWalls.has(`${x+1}-${y+1}`)) continue;
		if (Math.random() < 0.5) {
			cells[y][x + 1].vWall = true;
			cells[y + 1][x + 1].vWall = true;
		} else {
			cells[y + 1][x].hWall = true;
			cells[y + 1][x + 1].hWall = true;
		}
		// for (const row of cells) {
		// 	console.log(" " + row.map(r => (r.hWall ? "—" : " ") + (r.y > 0 && r.x < row.length - 1 && r.xyParity ? "•" : " ")).join(""));
		// 	console.log(row.map(r => (r.vWall ? "|" : " ") + (r.ribbon?.toString(36) ?? "-")).join(""));
		// }
	}

	return { cells, ribbons: calculateRibbons(cells) };
}

export function calculateRibbons(cells) {
	const unusedCells = new Set(cells.flat());
	const ribbons = [];
	while (unusedCells.size) {
		// const ribbonLabel = String.fromCharCode(ribbon++ + +65);
		let current = [...unusedCells][0];
		let direction = { x: 1, y: current.xyParity ? -1 : 1 };
		let ribbon = [];
		do {
			current.ribbon = ribbons.length;
			ribbon.push(current);
			unusedCells.delete(current);
			const vWall = direction.x > 0 ? cells[current.y][current.x + 1]?.vWall !== false : (current.vWall || current.x == 0),
				hWall = direction.y > 0 ? cells[current.y + 1]?.[current.x].hWall !== false : (current.hWall || current.y == 0);
			// console.log(current, {vWall,hWall}, direction)
			if (vWall) {
				current.next = { x: current.x, y: current.y + direction.y };
				direction = { x: -direction.x, y: direction.y };
			} else if (hWall) {
				current.next = { x: current.x + direction.x, y: current.y };
				direction = { x: direction.x, y: -direction.y };
			} else current.next = { x: current.x + direction.x, y: current.y + direction.y };
			const next = cells[current.next.y][current.next.x];
			next.previous = { x: current.x, y: current.y };
			current = cells[current.next.y][current.next.x];
			// for (const row of cells) console.log(row.map(r => r.ribbon?.toString(36) ?? "-").join(""));
		} while (unusedCells.has(current));
		ribbons.push(ribbon);
	}
	return ribbons;
}
